<template>
  <main class="w-full h-screen flex flex-col md:flex-row bg-white dark:bg-dark-500 overflow-hidden">
    <section class="w-full md:max-w-[600px] h-full flex flex-col justify-between p-6 md:p-8">
      <div class="flex items-center gap-x-4">
        <ChangeLanguage text-color="text-primary-500 dark:text-white" />
        <ChangeAppearance color-class="bg-transparent" color="!text-primary-500 dark:!text-white" />
      </div>

      <div class="flex-grow flex items-center justify-center">
        <LoginForm />
      </div>

      <footer
        class="flex flex-col items-center gap-2 text-sm text-gray-600 dark:text-gray-200 mt-auto"
      >
        <p class="opacity-50 text-[10px] font-medium tracking-wide">
          &copy; {{ new Date().getFullYear() }} ZAFAZ health. {{ t("all_rights_reserved") }}
        </p>
      </footer>
    </section>

    <section
      class="hidden md:flex flex-1 h-full bg-cover"
      :style="{ backgroundImage: `url(${bgImage})` }"
    />
  </main>
</template>

<script setup lang="ts">
  import LoginForm from "@/app/security/components/LoginForm.vue";
  import bgImage from "@/assets/auth/image-login.webp";
  import ChangeLanguage from "@/app/header/change_language/ChangeLanguage.vue";
  import ChangeAppearance from "@/app/header/change_appearance/ChangeAppearance.vue";
  import { useDefineTitlePage } from "@/shared/composables/useDefineTitlePage";
  import { useI18n } from "vue-i18n";

  const { t } = useI18n();

  useDefineTitlePage({
    title: "Login",
  });
</script>
